import appendQuery from "append-query";
import GrComponentFactory from "./gr_component_factory";
import GrPropTypes from "./shared/gr_prop_types";
import PaginationLinks from "./pagination_links";
import React from "react";

export default GrComponentFactory.createClass({
  displayName: "FullPagePaginationControls",

  propTypes: {
    currentPageNumber: React.PropTypes.number.isRequired,
    numWorks: GrPropTypes.naturalNumber.isRequired,
    perPage: GrPropTypes.naturalNumber.isRequired,
  },


  goToPage(destinationPage) {
    window.location.href =
      appendQuery(window.location.href, {
        page: destinationPage,
        per_page: this.props.perPage,
      });
  },

  render() {
    return (
      <PaginationLinks asButtons={true}
                       changePageAction={this.goToPage}
                       currentPageNumber={this.props.currentPageNumber}
                       perPage={this.props.perPage}
                       totalSize={this.props.numWorks} />
    );
  },
});
